export default "__VITE_ASSET__GXMe3kVa__"